<template>
  <div class="minW1060-auto bg-fff mag10 pad10">
    <el-row class="text-left">
      <div class="dlblock-mb20 mr10">
        <span class="pr5">名称</span>
         <el-input v-model.trim="name" placeholder="请输入" style="width: 150px;"/>
      </div>
      
	  <div class="dlblock-mb20 mr10">
	    <span class="pr5">创建时间</span>
	    <el-date-picker
	        v-model="createTime"
	        style="width: 180px;"
	        type="datetime"
	  			class="reset-clear"
	  			:clearable="false"
	  			 unlink-panels
	        value-format="yyyy-MM-dd HH:mm:ss"
	        start-placeholder="开始时间"
	        />
	  </div> 
	  
	  
	  	<div class="dlblock-mb20 mr10">
	    <span class="pr5">结束日期</span>
	    <el-date-picker
	      v-model="updateTime"
	  		  style="width: 180px;"
	      type="datetime"
	      :clearable="false"
	      unlink-panels
	      end-placeholder="结束时间"
	      value-format="yyyy-MM-dd HH:mm:ss"
	       />
	  </div> 
	  
      <div class="dlblock-mb20 mr10">
        <el-button type="primary" @click="pages.page = 1; getAQRCodeListPageFn()">
          搜索
        </el-button>
		
		<el-button type="primary" @click="editBtn(1)">
		  新增
		</el-button>
		
		<el-button type="primary" @click="editBtn(6)">
		 logo
		</el-button>
		
      </div>
    </el-row>
	
	
	<!-- 新增编辑 -->
	  <el-dialog :title="editData.add === 1 ? '新增二维码' : '编辑二维码'" :visible.sync="editData.modal" width="600px">
	    <el-form label-width="140px">
	      <el-form-item label="名称：">
	        <el-input v-model.trim="editData.name" placeholder="请输入名称"/>
	      </el-form-item>
	      <el-form-item label="类型：">
				<el-select v-model="editData.qRCodeType" class="w150" placeholder="必选" clearable>
				  <el-option v-for="(item, index) in qRCodeTypeList" :key="index" :label="item.name" :value="item.value"/>
				</el-select>
	      </el-form-item>
			<el-form-item label="二维码隐藏内容：">
			  <el-input v-model.trim="editData.url" placeholder="请输入二维码隐藏内容"/>
			</el-form-item>
			<el-form-item label="备注：">
			  <el-input v-model.trim="editData.remark" placeholder="非必须"/>
			</el-form-item>
	    </el-form>
	
	    <div slot="footer">
	      <el-button @click="editData.modal = false">取 消</el-button>
	      <el-button type="primary" @click="addBtn">确 定</el-button>
	    </div>
	  </el-dialog>
	  
	  
	  <!-- 新增编辑二维码logo -->
	    <el-dialog :title="editLogoData.add === 1 ? '新增二维码logo' : '编辑二维码logo'" :visible.sync="editLogoData.modal" width="600px">
	      <el-form label-width="140px">
	        <el-form-item label="名称：">
	          <el-input v-model.trim="editLogoData.name" placeholder="请输入名称"/>
	        </el-form-item>
			
			<el-form-item label="logo图片：">
				<el-row>
				  <aqrcode-logo class="mr10 mb10" v-model="editLogoData.logoPath" :id="aqrcodeLogoId" :total="1"/>
				</el-row>
			</el-form-item>
			
	  		<el-form-item label="备注：">
	  		  <el-input v-model.trim="editLogoData.remark" placeholder="非必须"/>
	  		</el-form-item>
	      </el-form>
	  
	      <div slot="footer">
	        <el-button @click="editLogoData.modal = false">取 消</el-button>
	        <el-button type="primary" @click="addLogoBtn">确 定</el-button>
	      </div>
	    </el-dialog>
	  
	  <!-- logo 查看设置 -->
	  <el-dialog title="二维码logo" :visible.sync="aQRCodeDialog.modal" width="600px">
	    <el-form label-width="140px">
		<div class="dlblock-mb20 mr10">
				<el-button type="primary" @click="editBtn(7)">
				  新增logo
				</el-button>
				
				<el-button type="primary" @click="getAQRCodeLogoListPageFn()">
				  刷新
				</el-button>
		</div>
	  	
		<!-- 二维码logo 列表 -->
		<el-table class="my-table" :data="subTableData" v-loading="tableLoading" :header-row-class-name="'my-table-header'">
		  <el-table-column align="center" prop="name" label="名称"></el-table-column>
		  <el-table-column align="center"  label="logo图片">
		    <template slot-scope="{row}">
		      <el-image class="m-box-img" :src="row.logoPath" @click="editBtn(5,row)" lazy></el-image>
		    </template>
		  </el-table-column>
		  <el-table-column align="center" prop="remark" label="备注"></el-table-column>
		  <el-table-column align="center" prop="createTime" label="创建时间"></el-table-column>
		  <el-table-column align="center" prop="updateTime" label="更新时间"></el-table-column>
		  <el-table-column align="center" width="150" label="操作">
		    <template slot-scope="{row}">
		      <a class="glob-a"  @click="editBtn(8, row)">修改</a>
			  <a class="glob-a"  @click="editBtn(9, row)">选中</a>
		      <a class="glob-a"  @click="editBtn(10, row)">删除</a> 
		    </template>
		  </el-table-column>
		</el-table> 
		
		<div class="my-pagination">
		  <el-pagination background layout="total, prev, pager, next" :total="pages.total"
		                 :current-page="pages.page" @current-change="pageChange">
		  </el-pagination>
		</div>
		
		</el-form>
	    <div slot="footer">
	      <el-button @click="aQRCodeDialog.modal = false">取 消</el-button>
	    </div>
	  </el-dialog>
	  

    <el-table class="my-table" :data="tableData" v-loading="tableLoading" :header-row-class-name="'my-table-header'">
      <el-table-column align="center" prop="name" label="名称"></el-table-column>
	  <el-table-column align="center" prop="type" label="类型"></el-table-column>
      <el-table-column align="center" prop="url" label="内容"></el-table-column>
	  
	  <el-table-column align="center"  label="图片">
	    <template slot-scope="{row}">
	      <el-image class="m-box-img" :src="row.picturePath" @click="editBtn(4,row)" lazy></el-image>
	    </template>
	  </el-table-column>
	  
	  <el-table-column align="center"  label="logo图片">
	    <template slot-scope="{row}">
	      <el-image class="m-box-img" :src="row.logoPath" @click="editBtn(5,row)" lazy></el-image>
	    </template>
	  </el-table-column>
	  
	  <el-table-column align="center" prop="createTime" label="创建时间"></el-table-column>
	  <el-table-column align="center" prop="updateTime" label="更新时间"></el-table-column>
	  <el-table-column align="center" width="150" label="操作">
	    <template slot-scope="{row}">
	      <a class="glob-a"  @click="editBtn(2, row)">修改</a>
	      <a class="glob-a"  @click="editBtn(3, row)">删除</a> 
	    </template>
	  </el-table-column>
	</el-table>  
	  
    <div class="my-pagination">
      <el-pagination background layout="total, prev, pager, next" :total="pages.total"
                     :current-page="pages.page" @current-change="pageChange">
      </el-pagination>
    </div>
	
	<!-- 图片放大 -->
	<el-dialog title="查看" :visible.sync="imgPreData.modal" width="600px">
	  <img style="width: 100%; height: 100%;" :src="imgPreData.url" alt="">
	</el-dialog>
	
  </div>
</template>

<script>
  import {
	//二维码管理  
    getAQRCodeListPage,
	aQrCodeSaveOrUpdate,
	//二维码logo管理
	getAQRCodeLogoListPage,
	aQrCodeLogoSaveOrUpdate,
	//二维码logo删除
	delAQrCodeLogo,
	//生成二维码logo选中
	aQrCodeLogoqSelection,
	//二维码列表删除
	aQrCodeDel
  } from '@/api'

   import AqrcodeLogo from '@/components/AQRCodeLogo.vue'


  export default {
    name: 'UserList',
	components: {AqrcodeLogo},
    data () {
      return {
		//二维码类型  
		qRCodeTypeList:[{name:"请选择",value:""},{name:"网址",value:"网址"},{name:"信息",value:"信息"},{name:"测试码",value:"测试码"}],
        // 图片放大
        imgPreData: {
          modal: false,
          url: ''
        },
		date: [],
        name: '',
		//二维码管理列表
        tableData: [],
		//二维码管理列表logo
		subTableData:[],
		//二维码logo id
		aqrcodeLogoId:'',
        tableLoading: false,
        pages: {
          page: 1,
          total: 0
        },
		createTime:'',
		updateTime:'',
		//二维码修改或添加
		editData: {
		  modal: false,
		  add: 1,
		  //编号
		  id:'',
		  //姓名
		  name: '',
		  //类型
		  qRCodeType:'',
		  //地址
		  url:'',
		  //备注
		  remark:''
		},
		//二维码logo修改或添加
		editLogoData:{
			modal: false,
			add: 1,
			//编号
			id:'',
			//名称
			name: '',
			//logo地址
			logoPath:''
		},
		//logo 查看设置
		aQRCodeDialog: {
		  modal: false
		}
      }
    },
    created () {
      this.getAQRCodeListPageFn()
    },
    methods: {
      getAQRCodeListPageFn () {
        this.tableLoading = true
        getAQRCodeListPage({
          pageNum: this.pages.page,
          name: this.name,
          createTime: this.createTime,
          updateTime: this.updateTime
        }).then(res => {
          this.tableData = res.data.records
          this.pages.total = res.data.total
		  console.info(this.tableData,"响应的数据")
        }).finally(() => {
          this.tableLoading = false
        })
      },
	  //二维码logo列表
	  getAQRCodeLogoListPageFn(){
		  this.tableLoading = true
		  getAQRCodeLogoListPage({
		    pageNum: this.pages.page,
		    name: this.name,
		    createTime: this.createTime,
		    updateTime: this.updateTime
		  }).then(res => {
		    this.subTableData = res.data.records
		    this.pages.total = res.data.total
		    console.info(this.subTableData,"二维码logo列表响应的数据")
		  }).finally(() => {
		    this.tableLoading = false
		  })
	  },
	  //二维码新增或修改
	  addBtn (t) {
	    if (this.editData.add == 1){
	  	  //添加
	  	  this.aQrCodeSaveOrUpdateFn()
	    } else {
	  	  //修改
	  	  this.aQrCodeSaveOrUpdateFn()
	    }
	  },
	  //二维码logo新增或修改
	  addLogoBtn(t){
		  if (this.editData.add == 1){
		    //添加
		    this.aQrCodeLogoSaveOrUpdateFn()
		  } else {
		    //修改
		    this.aQrCodeLogoSaveOrUpdateFn()
		  }
	  },
	  //二维码增加或更新
	  aQrCodeSaveOrUpdateFn(){
	    this.tableLoading = true
	    aQrCodeSaveOrUpdate({
	  	  id:this.editData.id,
	  	  //名称
	  	  name: this.editData.name,
	  	  //类型
	  	  type:this.editData.qRCodeType,
	  	  //HTTP访问地址
	  	  url:this.editData.url,
	  	  //备注
	  	  remark:this.editData.remark
	    }).then(res => {
	  	  this.editData.modal = false
	  	  this.$message.success(res.data)
	  	  this.getAQRCodeListPageFn();
	    }).finally(() => {
	      this.tableLoading = false
	    })
	  },
	  //二维码logo新增或修改 
	  aQrCodeLogoSaveOrUpdateFn () {
	    this.tableLoading = true
	    aQrCodeLogoSaveOrUpdate({
	  	  id:this.editLogoData.id,
	  	  //名称
	  	  name: this.editLogoData.name,
	  	  //logo地址
	  	  logoPath:this.editLogoData.logoPath[0],
	  	  //备注
	  	  remark:this.editLogoData.remark
	    }).then(res => {
	  	  this.editLogoData.modal = false
	  	  this.$message.success(res.data)
	  	  this.getAQRCodeLogoListPageFn()
	    }).finally(() => {
	      this.tableLoading = false
	    })
	  },
	  //二维码logo删除 
	  delAQrCodeLogoFn(id){
	    this.tableLoading = true
	    delAQrCodeLogo({
	  	  id:id,
	    }).then(res => {
	  	  this.editLogoData.modal = false
	  	  this.$message.success(res.msg)
	  	  this.getAQRCodeLogoListPageFn()
	    }).finally(() => {
	      this.tableLoading = false
	    })
	  },
	  //二维码列表删除
	  aQrCodeDelFn(id){
		  this.tableLoading = true
		  aQrCodeDel({
		    id:id,
		  }).then(res => {
		    this.$message.success(res.msg)
		    this.getAQRCodeListPageFn()
		  }).finally(() => {
		    this.tableLoading = false
		  })
	  },
	  //生成二维码logo选中
	  aQrCodeLogoqSelectionFn(id){  
		this.tableLoading = true
		aQrCodeLogoqSelection({
		  id:id,
		}).then(res => {
		  this.editLogoData.modal = false
		  this.$message.success(res.msg)
		  this.getAQRCodeLogoListPageFn()
		}).finally(() => {
		  this.tableLoading = false
		})
	  },
	  editBtn(t,row) {
	  		  //1新增 2修改 3删除 4查看里面的图片放大 5查看里面的logo图片放大 6logo列表查看 7新增logo 8修改logo 9二维码logo选中 10二维码logo删除
	  		  if(t == 1){
	  			 this.editData = {
	  			   modal: true,
	  			   add: 1,
	  			 }
	  		  }else if( t == 2 ){
				  console.info("修改二维码信息",row)
				 this.editData = {
				   modal: true,
				   add: 2,
				   id:row.id,
				   name:row.name,
				   qRCodeType:row.type,
				   url:row.url,
				   remark:row.remark
				 } 
			  }else if( t == 3 ){
				  //二维码列表删除
				  this.$confirm(`确认要删除吗`, '提示', {
				      confirmButtonText: '确定',
				      cancelButtonText: '取消',
				      type: 'warning'
				    }).then(() => {
				  	 let id =  row.id
				     //10二维码logo删除
				     this.aQrCodeDelFn(id)
				  });
			  }else if( t == 4 ){
				  this.imgPreData = {
				    modal: true,
					url:row.picturePath
				  }
			  }else if( t == 5 ){
				  this.imgPreData = {
				    modal: true,
				    url: row.logoPath
				  }
			  }else if( t == 6 ){
				  //logo设置
				  this.aQRCodeDialog = {
				    modal:true
				  }
				  this.getAQRCodeLogoListPageFn()
			  }else if( t == 7 ){
				  //新增logo
				  this.editLogoData = {
				    modal: true,
				    add: 1,
				  }
			  }else if( t == 8 ){
				//修改logo
				this.editLogoData = {
				  modal: true,
				  add: 2,
				  id:row.id,
				  name:row.name,
				  logoPath:row.logoPath,
				  remark:row.remark
				} 
				this.aqrcodeLogoId = row.id 
			  }else if( t == 9 ){
				  //9二维码logo选中 
				  this.$confirm(`确认选中logo生成二维码吗`, '提示', {
				      confirmButtonText: '确定',
				      cancelButtonText: '取消',
				      type: 'warning'
				    }).then(() => {
				  let id =  row.id
				  this.aQrCodeLogoqSelectionFn(id)
				  });
			  }else if( t == 10 ){
				  
				  this.$confirm(`确认要删除吗`, '提示', {
				      confirmButtonText: '确定',
				      cancelButtonText: '取消',
				      type: 'warning'
				    }).then(() => {
				  	 let id =  row.id
				     //10二维码logo删除
				     this.delAQrCodeLogoFn(id)
				  });
				 
			  }
	  },
      pageChange (val) {
        this.pages.page = val
        this.getAQRCodeListPageFn()
      },
    }
  }
</script>

<style scoped>

</style>
